import {useTheme} from "vuetify";

// Light/dark theme management for SimpliGPS Go web. The preference is stored
// locally (no backend column), mirroring the mobile app's theme setting.
const STORAGE_KEY = "app_theme";

export function useAppTheme() {
    const theme = useTheme();

    const apply = (name) => {
        theme.global.name.value = name === "dark" ? "dark" : "light";
    };

    // Apply the saved preference (call once at app start). Defaults to light.
    const init = () => {
        let saved = null;
        try {
            saved = localStorage.getItem(STORAGE_KEY);
        } catch (e) {
            saved = null;
        }
        if (saved === "dark" || saved === "light") apply(saved);
    };

    const setTheme = (name) => {
        const value = name === "dark" ? "dark" : "light";
        apply(value);
        try {
            localStorage.setItem(STORAGE_KEY, value);
        } catch (e) {
            // storage unavailable (private mode); theme is best-effort
        }
    };

    const isDark = () => theme.global.current.value.dark;

    return {init, setTheme, isDark};
}
